import React, { useContext } from "react";
import { Table, Thead, Tbody, Tr, Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useAccountSettingsUse24Hour } from "@/query/accountSettingsQuery";
import { colours } from "@/utils/themeUtils";
import { ScheduleRule, ScheduleTableRow } from "./ScheduleTableRow";
import { TableContainer, Th } from "../ui/Table";
import { ScheduleTableContext } from ".";
import { sortScheduleRules } from "./utils";

interface Props {
	classroomId: string;
	scheduleRules: ScheduleRule[];
	className?: string;
}

export function ScheduleTable(props: Props): JSX.Element {
	const { t } = useTranslation();
	const { showNewScheduleRow, duplicateSchedule } = useContext(ScheduleTableContext);
	const use24Hour = useAccountSettingsUse24Hour();
	const startTimeHeader = use24Hour ? t("scheduling.headerStartTime24") : t("scheduling.headerStartTime");
	const endTimeHeader = use24Hour ? t("scheduling.headerEndTime24") : t("scheduling.headerEndTime");

	return (
		<TableContainer>
			<Table variant={"qoriaStriped"}>
				<Thead>
					<Tr>
						<Th px={4}>{t("scheduling.headerDay")}</Th>
						<Th px={4}>{startTimeHeader}</Th>
						<Th px={4}>{endTimeHeader}</Th>
						<Th px={4}>{t("scheduling.headerEndDate")}</Th>
						<Th px={4} textAlign="center">
							{t("scheduling.headerActive")}
						</Th>
					</Tr>
				</Thead>
				<Tbody>
					{showNewScheduleRow && (
						<ScheduleTableRow
							isNewSchedule={true}
							classroomId={props.classroomId}
							schedule={duplicateSchedule}
							className={props.className}
						/>
					)}
					{!showNewScheduleRow && props.scheduleRules.length === 0 ? (
						<Tr>
							<Td colSpan={5} textAlign="center" py={8} color={colours.navy[700]}>
								{t("scheduling.noSchedulesFound")}
							</Td>
						</Tr>
					) : (
						sortScheduleRules(props.scheduleRules).map((schedule) => (
							<ScheduleTableRow
								key={schedule.id}
								isNewSchedule={false}
								schedule={schedule}
								classroomId={props.classroomId}
								className={props.className}
							/>
						))
					)}
				</Tbody>
			</Table>
		</TableContainer>
	);
}
